"use strict";

import {onFind} from "../libs/@elements/init-modules-in-scope";
import {updatePristine} from "./deliveryCheckoutForm";
import {updatePristineGuest} from "./deliveryCheckoutFormGuest";
import {
    on,
    setAttribute,
    closest,
    findIn,
    trigger
} from "../libs/@elements/dom-utils";

export function init() {
    onFind('.js-parsley-country', function (item) {
        let zipContainer = closest('.js-parsley-zip-container', item);
        let zipInput = findIn('.js-parsley-zip', zipContainer),
            zipRegex = item.selectedOptions[0].getAttribute('data-zip-regex'),
            zipError = item.selectedOptions[0].getAttribute('data-zip-regex-message');

        if (zipRegex) {
            setAttribute('data-pristine-pattern', '/' + zipRegex + '/', zipInput);
            setAttribute('data-pristine-pattern-message', zipError, zipInput);

            if (closest('.js-form-validation__delivery', item)) {
                updatePristine(closest('.js-form-validation__delivery', item));
            } else {
                updatePristineGuest(closest('.js-form-validation__delivery-guest', item));
            }
        }

        on('change', function() {
            zipRegex = item.selectedOptions[0].getAttribute('data-zip-regex');
            zipError = item.selectedOptions[0].getAttribute('data-zip-regex-message');

            setAttribute('data-pristine-pattern', '/' + zipRegex + '/', zipInput);
            setAttribute('data-pristine-pattern-message', zipError, zipInput);

            if (closest('.js-form-validation__delivery', item)) {
                updatePristine(closest('.js-form-validation__delivery', item));
            } else {
                updatePristineGuest(closest('.js-form-validation__delivery-guest', item));
            }

            trigger('input', zipInput);
        }, item);
    });
}